import { render } from "./SucursalList.vue?vue&type=template&id=88b553da&scoped=true"
import script from "./SucursalList.vue?vue&type=script&lang=js"
export * from "./SucursalList.vue?vue&type=script&lang=js"

import "./SucursalList.vue?vue&type=style&index=0&id=88b553da&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88b553da"]])

export default __exports__